import React, { useEffect } from 'react';
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
   card: {
      borderRadius: '5px',
      backgroundColor: '#F6F6F6',
      textAlign: 'center',
      minWidth: 150,
      padding: '5px 10px',
      width: '100%',
      lineHeight: 1,
   },
   allWalletCard: {
      backgroundColor: '#F383BB',
      color: 'white',
   },
   loading: {
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      height: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
}));

const Wallet = ({ totalPoint, rawPoints, isLoading }) => {
   const classes = useStyles();

   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };

   return (
      <div>
         {!isLoading ? (
            <Paper>
               <Box display={'flex'} padding={'10px'}>
                  <Box
                     className={`${classes.card} ${classes.allWalletCard}`}
                     marginRight={'10px'}
                  >
                     <Box>{/* image */}</Box>
                     <Box>
                        <Box fontSize={16}>กระเป๋า HR ทั้งหมด</Box>
                        <Box fontSize={22} fontWeight={'bold'}>
                           {costFormat(totalPoint)}
                        </Box>
                     </Box>
                  </Box>
                  {rawPoints &&
                     rawPoints.map((item, index) => (
                        <Box
                           key={index}
                           className={classes.card}
                           marginRight={
                              index !== rawPoints.length - 1 ? '10px' : 0
                           }
                        >
                           <Box>{/* image */}</Box>
                           <Box fontSize={16}>{item.walletName}</Box>
                           <Box fontSize={22} fontWeight={'bold'}>
                              {costFormat(item.remainPoints)}/
                              {costFormat(item.usedPoints)}
                           </Box>
                        </Box>
                     ))}
               </Box>
            </Paper>
         ) : (
            <div className={classes.loading}>
               <CircularProgress size={20} />
            </div>
         )}
      </div>
   );
};

export default Wallet;
